import { motion } from 'framer-motion';
import { resumeData } from '../data/resumeData';

export default function Header() {
  const { meta } = resumeData;

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header 
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed w-full bg-black/80 backdrop-blur-lg z-50"
    >
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        <a href="/" className="text-2xl font-display font-bold text-primary">
          {meta.name.split(' ')[0]}
        </a>
        
        <div className="flex items-center space-x-8">
          <nav className="hidden md:flex items-center space-x-8">
            {[
              { href: 'skills', text: 'Skills' },
              { href: 'experience', text: 'Experience' },
              { href: 'workshops', text: 'Workshops' },
              // { href: 'contact', text: 'Contact' }
            ].map(({ href, text }) => (
              <motion.a
                key={href}
                href={`#${href}`}
                onClick={(e) => handleNavClick(e, href)}
                className="text-gray-300 hover:text-primary transition-colors relative group"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {text}
                <motion.span
                  className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300"
                  whileHover={{ width: '100%' }}
                />
              </motion.a>
            ))}
          </nav>

          <motion.a 
            href="#contact"
            onClick={(e) => handleNavClick(e, 'contact')}
            className="hidden md:flex items-center px-4 py-2 bg-primary text-white rounded-full hover:bg-primary/90 transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get in Touch
          </motion.a>
        </div>
      </div>
    </motion.header>
  );
}